'use client';

import animationData from '@/animations/feature-account-management.json';
import { FC } from 'react';
import LottieHandler from './LottieHandler';

export interface AnimationFeatureAccountManagementProps {
  playing?: boolean;
}

const AnimationFeatureAccountManagement: FC<AnimationFeatureAccountManagementProps> = ({ playing }) => {
  return (
    <div className="aspect-[396/348]">
      <LottieHandler animationData={animationData} playing={playing} />
    </div>
  );
};

export default AnimationFeatureAccountManagement;
